import { BaseCommand } from '../../commands/base/base-command'
import { CanvasService } from '../canvas.service'

export type CanvasCommandType = 'invoker' | 'dialog-invoker'
export type CanvasCommandVariant = 'icon' | 'button'

/**
 * Live canvas state plus any command-specific fields. The index signature
 * lets each command carry extra data (e.g. the diagram data for save, or a
 * client-side delegate for undo) without a dedicated host type.
 */
export interface CanvasArgs {
  canvasId: number | null
  canvasTitle?: string
  hasUnsavedChanges?: boolean
  isSaving?: boolean
  isRunning?: boolean
  isTraceMode?: boolean
  hasTraces?: boolean
  canUndo?: boolean
  canRedo?: boolean
  [key: string]: any
}

/**
 * Base class for all canvas toolbar commands. Holds the {@link CanvasService}
 * so concrete commands can issue requests from their `doExecute`.
 */
export abstract class CanvasBaseCommand<
  TArgs extends CanvasArgs = CanvasArgs,
  TResult = unknown,
> extends BaseCommand<TArgs, TResult> {
  /** How the command is invoked: directly or through a dialog first. */
  abstract readonly type: CanvasCommandType
  /** Optional icon color when enabled. Gray when disabled. */
  readonly color?: string
  /** Render variant. */
  readonly variant: CanvasCommandVariant = 'icon'
  /** Button size for the 'button' variant. */
  readonly size: 'small' | 'medium' | 'large' = 'small'

  constructor(protected readonly canvasService: CanvasService) {
    super()
  }
}

/** Convenience alias used by hosts and invoker components. */
export type CanvasCommand = CanvasBaseCommand<CanvasArgs>
